import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { loadScriptOnce } from 'helpers/loadScriptAsync'
import PlaySVG from 'app/components/SVGS/Play'
import { EColors } from 'app/constants/colors'

import './styles.scss'
const bc = 'wistia-video'

export default class WistiaVideo extends Component {
  static defaultProps = {
    wistiaOptions: {
      popover: true,
      popoverAnimateThumbnail: true,
      playButton: true,
      playerColor: EColors.BLUE,
    },
    height: '100%',
    width: '100%',
  }

  static propTypes = {
    children: PropTypes.node,
    videoId: PropTypes.string.isRequired,
    videoThumbnail: PropTypes.string,
    alt: PropTypes.string,
    /**
     * @see https://wistia.com/support/developers/embed-options#using-embed-options
     * @see https://wistia.com/support/developers/embed-options#options-list
     */
    wistiaOptions: PropTypes.shape({
      playButton: PropTypes.bool,
      playerColor: PropTypes.string,
      popover: PropTypes.bool,
      popoverAnimateThumbnail: PropTypes.bool,
      popoverContent: PropTypes.oneOf(['html', 'link']),
      /** more @see https://wistia.com/support/developers/embed-options#options-list */
    }),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setShouldAutoPlayVideo: PropTypes.func,
  }

  state = {
    loaded: false,
  }

  timer

  async componentDidMount() {
    await loadScriptOnce('//fast.wistia.com/assets/external/E-v1.js')
    this.setState({ loaded: true })
    this.setWistiaOptions(this.props)
    this.autoPlayVideo(this.props)
  }

  componentDidUpdate(prevProps) {
    const { videoId } = this.props
    if ((videoId !== prevProps.videoId && videoId) || this.props.demo !== prevProps.demo) {
      this.setWistiaOptions(this.props)
      this.autoPlayVideo(this.props)
    }
  }

  componentWillUnmount() {
    this.timer && clearTimeout(this.timer)
    this.timer = null
    if (this.props.isAutoPlayVideo) {
      this.props.setShouldAutoPlayVideo()
    }
  }

  autoPlayVideo(props) {
    const { isAutoPlayVideo, videoId, demo } = props || this.props
    /*
      video will be played automatically either in case when the user onboarding tour in progress
      or when email letter contains autoPlay=true query param
    */
    if ((isAutoPlayVideo || demo) && !this.timer && window.Wistia) {
      // Documented functionality autoPlay does not work, also onReady and onEmbedded callbacks works wrong
      // that is why used this timeout due to play the video if isAutoPlayVideo=true
      this.timer = setTimeout(() => {
        const video = window.Wistia.api(videoId)
        clearTimeout(this.timer)
        this.timer = null
        video ? video.play() : this.autoPlayVideo()
      }, 200)
    }
  }

  setWistiaOptions(props) {
    const { videoId, wistiaOptions = {} } = props
    const options = {
      ...WistiaVideo.defaultProps.wistiaOptions,
      ...wistiaOptions,
    }
    window._wq = window._wq || []
    window._wq.push({
      id: videoId,
      options,
    })
  }

  render() {
    const { videoId, videoThumbnail, alt = 'Activity Video', height, width, children, wistiaOptions } = this.props
    const { loaded } = this.state
    if (loaded) {
      return (
        <div key={videoId} className={cn(`wistia_embed wistia_async_${videoId}`)} style={{ height, width }}>
          {wistiaOptions.popoverContent &&
            (children || (
              <div className={`${bc}__play-button`}>
                <PlaySVG width="8px" height="10px" />
              </div>
            ))}
        </div>
      )
    } else {
      if (wistiaOptions.popoverContent) {
        return (
          children || (
            <div className={`${bc}__play-button`}>
              <PlaySVG width="8px" height="10px" />
            </div>
          )
        )
      } else {
        return <img key={videoThumbnail} style={{ height, width }} src={videoThumbnail} alt={alt} />
      }
    }
  }
}
